/**
 * 학생정보조회 페이지로 이동하고 해당 학번으로 검색 (같은 탭)
 * @param {string} studentNumber - 학번 (10자리)
 */
export const openStudentInfoInNewTab = (studentNumber) => {
  if (studentNumber) {
    window.location.href = `/student-info?studentNumber=${encodeURIComponent(studentNumber)}`;
  }
};
